/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import {FormattedDate} from 'react-intl';

const LocalDayOfWeek = ({ data }) => (
    <FormattedDate
        value={data}
        day='numeric'
        month='2-digit'
        weekday="short"
    />
);

export default LocalDayOfWeek;


/** WEBPACK FOOTER **
 ** ./src/components/LocalDayOfWeek.jsx
 **/